import axios from 'axios'
import {useCallback, useEffect, useState} from 'react'


export function useCancelable(func: (isActive: () => boolean, source: any) => any) {
  return useCallback(() => {
    const source = axios.CancelToken.source()
    let isActive = true
    func(() => isActive, source.token)
    return () => {
      isActive = false
      source.cancel()
    }
  }, [func])
}

export function useCancelableEffect(
  func: (isActive: () => boolean, source: any) => any,
  deps: any
) {
  const effectCb = useCancelable(func)
  useEffect(effectCb, [...deps])
}

export function useCancelableFn<T>(
  callback: (props: T, isActive: () => boolean, token: any) => any
) {
  const [data, setData] = useState({
    timestamp: 0,
    props: {} as T,
  })

  const trigger = useCallback((props: T) => {
    setData({
      timestamp: Date.now(),
      props,
    })
  }, [])

  useEffect(() => {
    if (data.timestamp === 0) return

    let isActive = true
    const source = axios.CancelToken.source()

    callback(data.props, () => isActive, source.token)

    return () => {
      isActive = false
      source.cancel()
    }
  }, [data, callback])

  return trigger
}

